(function () {
  const changeIncompletePopup = () => {
    if (document.querySelector('#product-builder')?.dataset.productId === '8238141735085') {
      let frameHandle = null;
  
      const checkPopup = () => {
        const popup = document.querySelector('.swal2-popup.swal2-modal.swal2-icon-warning.swal2-show');
        if (popup) {
          const titleEl = popup.querySelector('.swal2-title');
          if (titleEl && titleEl.textContent.trim() === 'Product Incomplete') {
            titleEl.textContent = 'Product is out of stock';
  
            const htmlContainer = popup.querySelector('#swal2-html-container');
            if (htmlContainer) htmlContainer.innerHTML = '';
          }
        }
  
        frameHandle = requestAnimationFrame(checkPopup);
      };
  
      if (!frameHandle) {
        checkPopup();
      }
    }
  };

  const observeAddToCartClicks = () => {
    document.body.addEventListener('click', (e) => {
      const target = e.target.closest('cpb-add-to-cart-button');

      if (!target) return;

      const buttonText = target.textContent.trim().toLowerCase();
      if (buttonText.includes('add to cart')) {
        changeIncompletePopup();
      }
    });
  };

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    changeIncompletePopup();
  });

  observeAddToCartClicks();
})();